const MONTHS = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

// Dates arrive as YYYY-MM-DD. Read them as calendar dates, never through
// `new Date()`, which would shift them a day west of UTC.
export const formatDay = (iso) => {
  if (!iso) return "";
  const [y, m, d] = String(iso).slice(0, 10).split("-").map(Number);
  if (!y || !m || !d) return "";
  return `${MONTHS[m - 1]} ${d}, ${y}`;
};

export const daysLeftLabel = (daysLeft) => {
  if (daysLeft === null || daysLeft === undefined) return "No Board date";
  if (daysLeft === 0) return "Due today";
  if (daysLeft < 0) {
    const n = Math.abs(daysLeft);
    return `${n} day${n === 1 ? "" : "s"} past due`;
  }
  return `${daysLeft} day${daysLeft === 1 ? "" : "s"} left`;
};

export const deadlineTone = (row) => {
  if (row?.daysLeft !== null && row?.daysLeft !== undefined && row.daysLeft < 0) {
    return "failed";
  }
  return row?.deadlineTone || "neutral";
};

// Sent times are real moments (not calendar dates), so the browser's own
// time zone is the right one to read them in.
export const formatSentAt = (iso) => {
  if (!iso) return "";
  const moment = new Date(iso);
  if (Number.isNaN(moment.getTime())) return "";
  const day = `${MONTHS[moment.getMonth()]} ${moment.getDate()}, ${moment.getFullYear()}`;
  const hours = moment.getHours();
  const minutes = String(moment.getMinutes()).padStart(2, "0");
  const hour12 = hours % 12 || 12;
  return `${day}, ${hour12}:${minutes} ${hours < 12 ? "AM" : "PM"}`;
};

// "Russell Zimberlin <rzimberlin@zimberlinlaw.com>" -> "Russell Zimberlin";
// a bare address keeps its address.
export const personLabel = (address, name) => {
  if (name) return name;
  const raw = String(address || "").trim();
  const named = raw.match(/^"?([^"<]+?)"?\s*<[^>]+>$/);
  if (named) return named[1].trim();
  return raw.replace(/^<|>$/g, "");
};

export const BOARD_DECISION_MATCH = "carries a Board decision attachment";

export const decidedTone = (status) => {
  if (status === "signed_up") return "ready";
  if (status === "turned_down") return "failed";
  return "neutral";
};
